export class TimeControlBarDto {
  baseGridDate: Date;
  compareDate?: Date;

  constructor(init: Partial<TimeControlBarDto>) {
    Object.assign(this, init);
  }
}
